const findYPos = (element) => {
  let topPosition = 0

  if (element.offsetParent) {
    do {
      topPosition += element.offsetTop
    }
    while (element)
  }

  return topPosition
}

/**
 * Scrolls document to a specified element
 */
const scrollToElement = (elementOrElementId, smooth = true) => {
  let element

  if (typeof elementOrElementId === 'string') {
    element = document.getElementById(elementOrElementId)
  }
  else {
    element = elementOrElementId
  }

  if (element) {
    const elementOffsetTop  = element.offsetTop
    const isSmooth          = smooth && typeof window.scroll === 'function'

    if (isSmooth) {
      try {
        window.scroll({
          top: elementOffsetTop,
          left: 0,
          behavior: 'smooth',
        })
      }
      catch (err) {
        window.scrollTo(0, elementOffsetTop)
      }
    }
    else {
      window.scrollTo(0, elementOffsetTop)
    }
  }
  else {
    console.warn(`Element '${elementOrElementId}' not found`)
  }
}


export default scrollToElement
